import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_rubrics_path } from '@/modules/routes';

export interface IHolisticRubricDescription {
  level_id: number;
  description_id: number;
  score: number;
  description_en: string;
  description_es: string;
}

export interface IAnalyticRubricLevel {
  level_id: number | null;
  description_id: number | null;
  score: number;
  description_en: string;
  description_es: string;
}

export interface IAnalyticRubricCriterion {
  criterion_id: number | null;
  name_en: string;
  name_es: string;
  levels: IAnalyticRubricLevel[];
}

export interface IRubric {
  automatic_translation_enabled: boolean;
  id: number;
  name: string;
  rubric_type: 'analytic' | 'holistic';
  question_id: number;
  rubric_data: IHolisticRubricDescription[] | IAnalyticRubricCriterion[];
}

interface UseQuestionRubricProps {
  enabled?: boolean;
  questionId: number;
}

export const useQuestionRubric = ({ enabled = true, questionId }: UseQuestionRubricProps) => (
  useQuery({
    enabled: enabled && !!questionId,
    queryFn: () => (
      axios
        .get<{ data: IRubric[] }>(plato_api_rubrics_path({ for_question: questionId }))
        .then((res) => {
          if (res.data.data.length > 0) return res.data.data[0];

          return null;
        })
    ),
    queryKey: ['useRubric', { for_question: questionId }],
  })
);
